
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set } from "firebase/database";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBTPCQW8uhGQ7UkhDkEcB9Igq0IOUVXzCU",
  authDomain: "mixaplswed1602apl.firebaseapp.com",
  databaseURL: "https://mixaplswed1602apl-default-rtdb.firebaseio.com",
  projectId: "mixaplswed1602apl",
  storageBucket: "mixaplswed1602apl.firebasestorage.app",
  messagingSenderId: "670160539606",
  appId: "1:670160539606:web:b8f972dc1a00a5b4825e77",
  measurementId: "G-198G3DX5LV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get a reference to the database
const db = getDatabase(app);

export { db, ref, set };
